var map = {
	"./App": 61852,
	"./App.vue": 61852,
	"./assets/css/global.scss": 70656,
	"./assets/css/reset.scss": 64410,
	"./assets/css/utils.scss": 76906,
	"./assets/fonts/bold.ttf": 15388,
	"./assets/fonts/font.css": 7903,
	"./assets/fonts/medium.ttf": 17607,
	"./assets/icons": 17258,
	"./assets/icons/": 17258,
	"./assets/icons/index": 17258,
	"./assets/icons/index.js": 17258,
	"./assets/icons/svg/icon-arrow.svg": 51089,
	"./assets/icons/svg/icon-change.svg": 49503,
	"./assets/icons/svg/icon-close.svg": 50829,
	"./assets/icons/svg/icon-copy.svg": 54171,
	"./assets/icons/svg/icon-edit.svg": 47766,
	"./assets/icons/svg/icon-lfg.svg": 54012,
	"./assets/icons/svg/icon-lock.svg": 20111,
	"./assets/icons/svg/icon-ok.svg": 35686,
	"./assets/icons/svg/icon-refresh.svg": 82037,
	"./assets/icons/svg/icon-telegram.svg": 45810,
	"./assets/js/noZoom": 62654,
	"./assets/js/noZoom.js": 62654,
	"./assets/js/rem": 79633,
	"./assets/js/rem.js": 79633,
	"./components/assetsInfo": 84737,
	"./components/assetsInfo.vue": 84737,
	"./components/assetsInfoE": 51679,
	"./components/assetsInfoE.vue": 51679,
	"./components/assetsInfoM": 40099,
	"./components/assetsInfoM.vue": 40099,
	"./components/assetsInfoR": 37630,
	"./components/assetsInfoR.vue": 37630,
	"./components/assetsInfoX": 76727,
	"./components/assetsInfoX.vue": 76727,
	"./components/layout": 31401,
	"./components/layout.vue": 31401,
	"./components/myLoading": 59478,
	"./components/myLoading/": 59478,
	"./components/myLoading/index": 59478,
	"./components/myLoading/index.js": 59478,
	"./components/myLoading/myLoading": 91899,
	"./components/myLoading/myLoading.scss": 40735,
	"./components/myLoading/myLoading.vue": 91899,
	"./components/page/pageDiamond": 96168,
	"./components/page/pageDiamond.vue": 96168,
	"./components/page/pageInvite": 49833,
	"./components/page/pageInvite.vue": 49833,
	"./components/page/pageMarket": 40592,
	"./components/page/pageMarket.vue": 40592,
	"./components/page/pageMine": 42349,
	"./components/page/pageMine.vue": 42349,
	"./components/page/pageMiner": 51331,
	"./components/page/pageMiner.vue": 51331,
	"./components/page/pageMinerDetail": 21059,
	"./components/page/pageMinerDetail.vue": 21059,
	"./components/page/pageRecruit": 20404,
	"./components/page/pageRecruit.vue": 20404,
	"./components/page/pageUpgradeStar": 1691,
	"./components/page/pageUpgradeStar.vue": 1691,
	"./components/popBindWallet": 13619,
	"./components/popBindWallet.vue": 13619,
	"./components/popCoinSell": 68582,
	"./components/popCoinSell.vue": 68582,
	"./components/popGemInfo": 39269,
	"./components/popGemInfo.vue": 39269,
	"./components/popGemMint": 38065,
	"./components/popGemMint.vue": 38065,
	"./components/popGoMine": 91814,
	"./components/popGoMine.vue": 91814,
	"./components/popGuide": 82760,
	"./components/popGuide.vue": 82760,
	"./components/popMarketInfo": 32239,
	"./components/popMarketInfo.vue": 32239,
	"./components/popMyMarket": 51193,
	"./components/popMyMarket.vue": 51193,
	"./components/popMyMine": 62943,
	"./components/popMyMine.vue": 62943,
	"./components/popPrompt": 61097,
	"./components/popPrompt.vue": 61097,
	"./components/popRanking": 26712,
	"./components/popRanking.vue": 26712,
	"./components/popRecruitInfo": 83317,
	"./components/popRecruitInfo.vue": 83317,
	"./components/popRecruitMiner": 40123,
	"./components/popRecruitMiner.vue": 40123,
	"./components/popSelect": 70108,
	"./components/popSelect.vue": 70108,
	"./components/popSelectMiner": 53121,
	"./components/popSelectMiner.vue": 53121,
	"./components/popSell": 91049,
	"./components/popSell.vue": 91049,
	"./components/popSetting": 67705,
	"./components/popSetting.vue": 67705,
	"./components/popSwitchMine": 42862,
	"./components/popSwitchMine.vue": 42862,
	"./components/popTask": 11410,
	"./components/popTask.vue": 11410,
	"./components/popUpgradeMiner": 43692,
	"./components/popUpgradeMiner.vue": 43692,
	"./components/popUpgradeWarehouse": 32420,
	"./components/popUpgradeWarehouse.vue": 32420,
	"./components/svgIcon": 43234,
	"./components/svgIcon.vue": 43234,
	"./directive": 90973,
	"./directive/": 90973,
	"./directive/direct/v-anchor": 52828,
	"./directive/direct/v-anchor.js": 52828,
	"./directive/direct/v-copy": 44404,
	"./directive/direct/v-copy.js": 44404,
	"./directive/direct/v-debounce": 64459,
	"./directive/direct/v-debounce.js": 64459,
	"./directive/direct/v-draggable": 52971,
	"./directive/direct/v-draggable.js": 52971,
	"./directive/direct/v-scroll": 57660,
	"./directive/direct/v-scroll.js": 57660,
	"./directive/direct/v-shuibowen": 73131,
	"./directive/direct/v-shuibowen.js": 73131,
	"./directive/index": 90973,
	"./directive/index.js": 90973,
	"./game": 77407,
	"./game/": 77407,
	"./game/animate": 72964,
	"./game/animate.js": 72964,
	"./game/common": 5447,
	"./game/common.js": 5447,
	"./game/components/CTab": 29230,
	"./game/components/CTab.js": 29230,
	"./game/components/TextInput": 24522,
	"./game/components/TextInput.js": 24522,
	"./game/config/assetsManifest": 23674,
	"./game/config/assetsManifest.json": 23674,
	"./game/disablePc": 49270,
	"./game/disablePc.js": 49270,
	"./game/filter": 33557,
	"./game/filter.js": 33557,
	"./game/fontStyle": 69329,
	"./game/fontStyle.js": 69329,
	"./game/gameAssets": 75980,
	"./game/gameAssets.js": 75980,
	"./game/index": 77407,
	"./game/index.js": 77407,
	"./game/indexedDB": 61169,
	"./game/indexedDB.js": 61169,
	"./game/loading": 79632,
	"./game/loading.js": 79632,
	"./game/music": 717,
	"./game/music.js": 717,
	"./game/pool": 75346,
	"./game/pool.js": 75346,
	"./game/spriteFrame": 91116,
	"./game/spriteFrame.js": 91116,
	"./game/styles": 55488,
	"./game/styles/": 55488,
	"./game/styles/index": 55488,
	"./game/styles/index.js": 55488,
	"./game/uiComponents": 15976,
	"./game/uiComponents.js": 15976,
	"./http": 11063,
	"./http/": 11063,
	"./http/index": 11063,
	"./http/index.js": 11063,
	"./i18n": 86926,
	"./i18n/": 86926,
	"./i18n/i18nOption": 17292,
	"./i18n/i18nOption.json": 17292,
	"./i18n/index": 86926,
	"./i18n/index.js": 86926,
	"./i18n/json/Chs": 15077,
	"./i18n/json/Chs.json": 15077,
	"./i18n/json/En": 74030,
	"./i18n/json/En.json": 74030,
	"./main": 43217,
	"./main.js": 43217,
	"./mixins/gameMixin": 25914,
	"./mixins/gameMixin.js": 25914,
	"./mixins/guide": 78845,
	"./mixins/guide.js": 78845,
	"./router": 15092,
	"./router/": 15092,
	"./router/index": 15092,
	"./router/index.js": 15092,
	"./store": 68854,
	"./store/": 68854,
	"./store/index": 68854,
	"./store/index.js": 68854,
	"./store/modules/game": 52983,
	"./store/modules/game.js": 52983,
	"./store/modules/user": 69220,
	"./store/modules/user.js": 69220,
	"./store/modules/wallet": 9944,
	"./store/modules/wallet.js": 9944,
	"./tonWallet": 88929,
	"./tonWallet/": 88929,
	"./tonWallet/config/config": 73649,
	"./tonWallet/config/config.json": 73649,
	"./tonWallet/config_for_test/config": 46398,
	"./tonWallet/config_for_test/config.json": 46398,
	"./tonWallet/index": 88929,
	"./tonWallet/index.js": 88929,
	"./utils": 1474,
	"./utils/": 1474,
	"./utils/errcode": 48956,
	"./utils/errcode.js": 48956,
	"./utils/formatter": 83291,
	"./utils/formatter.js": 83291,
	"./utils/index": 1474,
	"./utils/index.js": 1474,
	"./view": 49321,
	"./view/": 49321,
	"./view/index": 49321,
	"./view/index.vue": 49321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;